import React, { useContext } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import Icons from '../../../common/icons/Icons'
import Button from '../../../common/button/Button'
import { useGroupDashboardContext } from '../GroupDashboardContext'
import { notAllowedUserMembershipStatus } from '../Members/Members/Utils'
import Micromodal from 'micromodal'
import { addMemberModalId } from '../Members/form/Utils'
import AddMemberModal from '../Members/form/AddMemberModal'
import AddTeamSeats from '../TeamSettings/AddTeamSeats'
import { TeamContext } from './MenuTabs'
import { addSeatVisibility } from '../TeamSettings/Utils'
import { addAssignLicensesModalId } from '../Licenses/header/Utils'
import AssignLicensesModal from '../Licenses/header/AssignLicenses'
import { addManageBillingModalId } from './Utils'
import ManageBillingModal from '../Organization/ManageBillingModal'

const TeamTabs = ({ teamData, teamURL = [], teamOptionsData, teamType }) => {

    const params = useParams()
    const teamId = params.team_id
    const root = `/organization/${teamId}`
    const memberModalId = addMemberModalId(teamId)
    const assignLicensesModalId = addAssignLicensesModalId(teamId)
    const manageBillingModalId = addManageBillingModalId(teamId)
    const { filtersData, setSelectedAddMemberModal } = useGroupDashboardContext()
    const { refetchTeamData } = useContext(TeamContext);

    // console.log('teamData : ', teamData)

    const handleAddMembers = () => {
      if ( teamType === 'wooteams' ) {
        setSelectedAddMemberModal({
          teamId: teamId,
          remainingSeats: teamData.team_remaining_seats,
          seatCount: teamData.team_seat_count,
          teamType: teamType
        })
      } else if ( teamType === 'msynclicenses' ) {
        setSelectedAddMemberModal({
          teamId: teamId,
          teamType: teamType
        })
      }
      Micromodal.show(memberModalId)
    }

    const handleAssignLicenses = () => {
      Micromodal.show(assignLicensesModalId)
    }

    const handleManageBilling = () => {
      Micromodal.show(manageBillingModalId)
    }

    const handleMangeSeats = () => {
      Micromodal.show('msync-modal-manage-seats')
    }

    return (
      <>
      {
        <nav className="msync-organization-dashboard__header__navigation" id='msync-team-tabs'>
          <div className="msync-organization-dashboard__header__navigation__part msync-organization-dashboard__header__navigation__part--nav-main">
            <NavLink
              to={`${root}`}
              className={({ isActive }) => isActive ? "active msync-button" : "msync-button msync-button--is-theme-secondary msync-button--is-style-link" }
              end
            >
              <Icons type='home' color='currentcolor'/>
              <span>Home</span>
            </NavLink>
            <NavLink
              to={`${root}/members`}
              className={({ isActive }) => isActive ? "active msync-button" : "msync-button msync-button--is-theme-secondary msync-button--is-style-link" }
            >
              <Icons type='users' color='currentcolor' />
              <span>Members</span>
            </NavLink>
            { teamType === 'msynclicenses' && teamData.member_role !== 'member' && <NavLink
              to={`${root}/licenses`}
              className={({ isActive }) => isActive ? "active msync-button" : "msync-button msync-button--is-theme-secondary msync-button--is-style-link" }
            >
              <Icons type='licenses' color='currentcolor' />
              <span>Licenses</span>
            </NavLink> }
            { teamType === 'msynclicenses' && teamData.can_view_reports && <NavLink
              to={`${root}/reporting-group`}
              className={({ isActive }) => isActive ? "active msync-button" : "msync-button msync-button--is-theme-secondary msync-button--is-style-link" }
            >
              <Icons type='reporting-group' color='currentcolor' />
              <span>Reports</span>
            </NavLink> }
            { teamType === 'wooteams' && <NavLink
              to={`${root}/reporting-group`}
              className={({ isActive }) => isActive ? "active msync-button" : "msync-button msync-button--is-theme-secondary msync-button--is-style-link" }
            >
              <Icons type='reporting-group' color='currentcolor' />
              <span>Reports</span>
            </NavLink> }
            <NavLink
              to={`${root}/team-settings`}
              className={({ isActive }) => isActive ? "active msync-button" : "msync-button msync-button--is-theme-secondary msync-button--is-style-link" }
            >
              <Icons type='settings' color='currentcolor' />
              <span>{ filtersData.woo.teams.singular_label } Settings</span>
            </NavLink>
          </div>
          <div className="msync-organization-dashboard__header__navigation__part">
            {
              ( teamData.team_seat_count !== null && filtersData.home?.manage_seats_nav_button_visibility && addSeatVisibility( teamData ) ) &&
              <Button
                className="msync-button--is-style-outline"
                onClick={ () => handleMangeSeats() }
              >
                <Icons type='users' height={ '1em' } width={ '1em' } color="currentcolor" />
                <span>{ filtersData.home?.manage_seats_nav_button_label }</span>
              </Button>
            }
            {   
              teamType === 'msynclicenses' && filtersData.home?.manage_billing_nav_button_visibility &&
              ( notAllowedUserMembershipStatus.includes(teamData.current_user_membership?.membership_status)
              ? <button type='button' className='msync-button' disabled>{ filtersData.home?.manage_billing_nav_button_label }</button>
              : teamData.member_role !== 'member' && <>
                  <Button
                    className="msync-button--is-style-outline"
                    onClick={ () => handleManageBilling() }
                  >
                    <Icons type='manage-billing' height={ '1em' } width={ '1em' } color="currentcolor" />
                    <span>{ filtersData.home?.manage_billing_nav_button_label }</span>
                  </Button>
                </>
              )
            }
            {   
              ( teamData.can_add_members || teamType !== 'msynclicenses' ) && ( filtersData.home?.add_member_nav_button_visibility &&
              ( notAllowedUserMembershipStatus.includes(teamData.current_user_membership?.membership_status)
              ? <button type='button' className='msync-button' disabled>{ filtersData.home?.add_member_nav_button_label }</button>
              : <>
                  <Button
                    className="msync-button--is-style-outline"
                    onClick={ () => handleAddMembers() }
                  >
                    <Icons type='add-member' height={ '1em' } width={ '1em' } color="currentcolor" />
                    <span>{ filtersData.home?.add_member_nav_button_label }</span>
                  </Button>
                </>
              ) )
            }
            {   
              teamType === 'msynclicenses' && filtersData.home?.assign_licenses_nav_button_visibility && teamData.can_assign_licenses &&
              ( notAllowedUserMembershipStatus.includes(teamData.current_user_membership?.membership_status)
              ? <button type='button' className='msync-button' disabled>{ filtersData.home?.assign_licenses_nav_button_label }</button>
              : <>
                  <Button
                    className="msync-button--is-style-outline"
                    onClick={ () => handleAssignLicenses() }
                  >
                    <Icons type='assign-licenses' height={ '1em' } width={ '1em' } color="currentcolor" />
                    <span>{ filtersData.home?.assign_licenses_nav_button_label }</span>
                  </Button>
                </>
              )
            }
          </div>
        </nav>
      }
      {
        teamType === 'msynclicenses' && filtersData.home?.assign_licenses_nav_button_visibility &&
        !notAllowedUserMembershipStatus.includes(teamData.current_user_membership?.membership_status) &&
          <AssignLicensesModal
            isAdmin={ teamData.is_user_admin }
            teamId={ teamId }
            data={ teamData.assign_licenses_data }
          />
      }
      {
        teamType === 'msynclicenses' && filtersData.home?.assign_licenses_nav_button_visibility &&
        !notAllowedUserMembershipStatus.includes(teamData.current_user_membership?.membership_status) && 
        teamData.member_role !== 'member' &&
          <ManageBillingModal
            isAdmin={ teamData.is_user_admin }
            teamId={ teamId }
            data={ teamData.plan_data }
          />
      }
      {
        filtersData.home?.add_member_nav_button_visibility &&
        ( ! notAllowedUserMembershipStatus.includes(teamData.current_user_membership?.membership_status) &&
          <AddMemberModal 
            isAdmin={ teamData.is_user_admin } 
            modalOption={ teamData.members_modal_option } 
            teamId={ teamId }
            navigateTo={ teamType === 'wooteams' ? `${root}/members` : ''}
            refetchAdded={ refetchTeamData }
            refetchInvited={ refetchTeamData }
          />
        )
      }
      { 
        ( filtersData.home?.manage_seats_nav_button_visibility && addSeatVisibility( teamData ) ) &&
        <AddTeamSeats 
          from='manage-seats' 
          teamData={ teamData } 
          refetchTeamData={ refetchTeamData } 
          teamOptionsData={ teamOptionsData } 
        /> 
      }
      </>
    )
}

export default TeamTabs
